import { Button } from '@estac1/ui';
import { ChevronDown, ChevronRight } from 'lucide-react';
import type { AuditEntry } from './types.js';
import { formatAt, hasDiff } from './utils.js';

interface AuditMobileListProps {
  entries: AuditEntry[];
  expanded: Set<string>;
  onToggle: (id: string) => void;
}

export const AuditMobileList = ({ entries, expanded, onToggle }: AuditMobileListProps) => (
  <ul className="divide-y divide-border md:hidden">
    {entries.map((e) => {
      const canExpand = hasDiff(e.diff);
      const isOpen = expanded.has(e.id);
      return (
        <li key={e.id} className="space-y-2 px-4 py-3">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="font-mono text-xs text-muted-fg">{formatAt(e.at)}</p>
              <p className="truncate text-sm">
                {e.actorEmail ?? `${e.actorType}/${e.id.slice(0, 8)}`}
              </p>
              <p className="truncate font-mono text-xs">
                {e.action} · {e.entity}
                {e.entityId ? ` · ${e.entityId}` : ''}
              </p>
            </div>
            {canExpand ? (
              <Button
                variant="ghost"
                size="icon"
                className="shrink-0"
                aria-label={isOpen ? 'Recolher detalhes' : 'Ver detalhes'}
                onClick={() => onToggle(e.id)}
              >
                {isOpen ? (
                  <ChevronDown className="h-4 w-4" />
                ) : (
                  <ChevronRight className="h-4 w-4" />
                )}
              </Button>
            ) : null}
          </div>
          {isOpen && canExpand && (
            <pre className="overflow-x-auto whitespace-pre-wrap break-all rounded bg-muted/40 p-3 font-mono text-xs">
              {JSON.stringify(e.diff, null, 2)}
            </pre>
          )}
        </li>
      );
    })}
  </ul>
);
